

export const displayNameIsNull = (user) => {
    const { isAnonymous, displayName } = user;
    return !isAnonymous && displayName === null
}

export const isUserAnonymous = (isAnonymous) => {    
    if (isAnonymous) {
        window.alert('This feature is only available to logged in users.');
        return true
    }
    return false
}

export const sendVerificationEmail = (emailVerified, isAnonymous) => {
    return !emailVerified && !isAnonymous
}
export const hasAnonymousUserContributed = (isAnonymous, contributors) => {
    return isAnonymous && contributors.includes(null)
}
export const lessThan5Contributions = (contributorIDs, user) => {
    return contributorIDs.length <= 5 && contributorIDs.includes(user.uid);
}
export const moreThan5Contributions = (contributorIDs, user) => {
    let lastContribution = contributorIDs.lastIndexOf(user.uid);
    return contributorIDs.length > 5 && contributorIDs.length - lastContribution < 5;
}